<template>
    <div class="container lnb d_container">
        <div class="contents_wrap">
            <div class="contents list-container">
                <div class="title">
                    공모전 상세정보
                </div>
                <div class="write_tab">
                    <div class="write_tab_content tab_contents active"
                         >
                        기본정보
                    </div>
                    <div class="write_tab_content tab_contents"
                         @click="movePage(`/competition/list/${competitionKey}/entry`)"
                         v-show="competitionStatus !== 0">
                        응모작
                    </div>
                    <div class="write_tab_content tab_contents"
                         @click="movePage(`/competition/list/${competitionKey}/award`)"
                         v-show="competitionStatus !== 0">
                        수상작
                    </div>
                </div>
                <div class="member_write_wrap">
                    <div class="write_content">
                        <div class="write_box" >
                        <competition-write-component :competitionType="`detail`"
                                                     :competitionKey="competitionKey"></competition-write-component>
                            <div class="btn_box">
                                <el-button class="com_btn" @click="backEvent()">목록</el-button>
                                <el-button class="com_del" @click="deleteCompetition()"
                                v-show="competitionStatus !== 3">삭제</el-button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <judge-info-modal></judge-info-modal>
        <judge-result-modal></judge-result-modal>
        <option-modal></option-modal>
    </div>
</template>

<script>
import CompetitionWriteComponent from "@/components/competition/CompetitionWriteComponent";
import CompetitionListComponent from "@/components/competition/CompetitionListComponent";
import JudgeInfoModal from "@/components/modal/JudgeInfoModal";
import JudgeResultModal from "@/components/modal/JudgeResultModal";
import OptionModal from "@/components/modal/OptionModal";
import EventBus from "@/utils/event-bus";
export default {
    name: "CompetitionDetail",
    mixins: [],
    components: {
        CompetitionWriteComponent,
        CompetitionListComponent,
        JudgeInfoModal,
        JudgeResultModal,
        OptionModal
    },
    inject: [],
    provide() {
        return {}
    },
    props: {},
    data() {
        return {
            tab: 'detail',
            competitionKey: this.$route.params.idx,
            isBack:false,
            competitionStatus : ''
        }
    },
    beforeRouteEnter(from,to,next) {
        next()
    },
    created() {
    },
    mounted() {
        this.isBack = false
        EventBus.$on('CompetitionVueSetData',this.setData)
    },
    beforeDestroy() {
        EventBus.$off('CompetitionVueSetData')
    },
    destroyed() {
    },
    beforeRouteLeave(from,to,next){
        if(this.isBack){
            this.isBack = false
            if(from.path === `/competition/list/${this.competitionKey}/award` || from.path === `/competition/list/${this.competitionKey}/entry`){
                next('/competition/list')
            } else {
                next()
            }
        }else {
            next()
        }
    },
    computed: {},
    methods: {
        changeTab(tab) {
            this.$router.replace(this.$route.path);
            this.tab = '';
            this.$nextTick(() => {
                this.tab = tab
            })
        },
        deleteCompetition() {
            EventBus.$emit('deleteCompetition')
        },
        movePage(url){
            this.$router.push(url)
        },
        backEvent(){
            this.isBack = true
            this.$router.back()
        },
        setData(key,value){
            this[key] = value
        }
    },
    watch: {},
}
</script>

<style scoped>

</style>
